import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import './styles.css';
import { Container, Row } from 'reactstrap';
import SignUpForm from '../../components/elements/forms/SignUpForm';
import { IS_SIDEKICK_APP } from '../../constants/projects';
import { ReactComponent as BackButtonIcon } from './back-button.svg';
import * as ROUTES from '../../constants/routes';

const SignUpPage = () => {
    const navigate = useNavigate();

    const handleBackButtonClick = useCallback(() => {
        navigate(ROUTES.SIGN_IN);
    }, [navigate]);

    return (
        <Container
            className={classNames('unauthorized-signup__container', {
                'unauthorized-signup__container--sidekick': IS_SIDEKICK_APP,
            })}
        >
            <Row className="unauthorized-signup">
                <div
                    className="unauthorized-signup__back-button-container cursor-pointer"
                    onClick={handleBackButtonClick}
                >
                    <BackButtonIcon />
                </div>
                <div>
                    <h5 className="unauthorized-signup-title">
                        Sign up, it&apos;s completely free!
                    </h5>
                </div>
                <div>
                    <SignUpForm />
                </div>
            </Row>
        </Container>
    );
};

SignUpPage.propTypes = {};

export default React.memo(SignUpPage);
